/* eslint-disable jsx-a11y/anchor-is-valid */
import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useNavigate } from "react-router-dom";
import { getUserAuth } from './api'
import { getComapnyByKey, goToLink } from './projectData'
import { FullPageLoader } from '../component/helper'



export function CustomerLoginWithoutPassword() {

    const { companyname, key, memberid, mobile, user_type, user_name, total_point, address } = useParams();
    const loginLink = window.location.href
    const [loading, setLoading] = useState(true)
    const [response, setResponse] = useState('')
    const navigate = useNavigate();

    useEffect(() => {
        // Check if any parameter is missing
        //  const requiredParams = { companyname, key, memberid, mobile, user_type, user_name, total_point, address };
        if (!companyname || !key || !memberid || !mobile || !user_type || !user_name || !total_point || !address) {
            // const missing = Object.entries(requiredParams).filter(([_, value]) => !value).map(([key]) => key);
            // setMissingFields(missing);
            return;
        }
        const projectData = getComapnyByKey(companyname);
        const data = {
            secret_key: key,
            project_key: projectData?.pkey,
            memberid,
            mobile,
            user_type,
            user_name,
            total_point,
            address,
            loginLink
        };

        // Make the API call
        const fetchData = async () => {
            try {
                const responseToken = await getUserAuth(data)

                if (Number(responseToken.code) === 1) {
                    setLoading(false)
                    localStorage.setItem('cuslogin', JSON.stringify(responseToken?.data))
                    localStorage.setItem('pkey', projectData?.pkey)
                    localStorage.setItem('company', companyname)
                    goToLink(navigate, '/customer/dashboard', [])
                    setTimeout(() => {
                        window.location.reload();
                    }, 500);
                    //navigate('/customer/dashboard')
                } else {
                    setTimeout(() => {
                        setLoading(false)
                    }, 500);

                    setResponse(responseToken || 'Login Token Error');
                }

            } catch (error) {
                console.error('API error:', error);
            }
        };

        fetchData();
    }, [key, memberid, mobile, user_type, user_name, total_point, address, navigate, companyname]);



    return (
        <div className="d-flex flex-column align-items-center vh-100  p-2 mt-6" style={{ backgroundColor: "#fff" }}>
            {/* <div className="w-100 mb-3 p-3 bg-light rounded border">
                <div className="fw-semibold mb-1">Login Link</div>
                <div className="text-break fs-7" style={{ wordBreak: 'break-all' }}>{loginLink}</div>
            </div> */}
            {loading ? <FullPageLoader></FullPageLoader> : <>
                <div className='d-flex justify-content-center'>
                    <img src={`/media/auth/error.png`} className="" alt="" style={{ width: '150px', height: '150px' }} />
                </div>

                <div style={{ border: '1px solid #dadada' }} className="card card-flush w-100">
                    <div style={{ background: '#FBF6F7', minHeight: '39px' }} className="card-header p-3">
                        <div style={{ color: '#FF4141' }} className="card-title">Authentication error !</div>
                    </div>
                    <div className="card-body">
                        <div style={{ color: '#000' }} className="fs-6 w-100">
                            {response && (
                                <div className="alert alert-danger rounded-3 shadow-sm py-3 px-4 mb-3" style={{ background: "#fff0f3", border: "1px solid #ffb3b3" }}>
                                    {response?.message && (
                                        <div className="fw-bold mb-2" style={{ color: "#d32f2f", fontSize: "1.15rem" }}>
                                            {response.message}
                                        </div>
                                    )}
                                    {Array.isArray(response?.data) && response.data.length > 0 && (
                                        <ul className="mb-0 ps-4" style={{ color: "#b71c1c", fontSize: "1rem", lineHeight: "1.6" }}>
                                            {response.data.map((item, idx) => (
                                                <li key={idx} className="mb-1">{item}</li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                        <div>
                        </div>
                    </div>
                </div>
            </>}

        </div>

    )
}
